var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _class2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { reads } from '@ember/object/computed';
import { belongsTo } from '@ember-data/model';
import ItemsV3Base from '@square/dashboard-items-data/models/items-v3-base';
// these two imports are causing failures when running the prepublish step in frontend/@dashboard/sales-tax-shared/package.json step in kochiku:
// e.g. "'Item' is declared but its value is never read.""
// The below ts-ignore comments are safe, because these types are in fact used.
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
let ItemFeeMembership = (_dec = belongsTo('item', {
  async: false
}), _dec2 = belongsTo('fee', {
  async: false
}), _dec3 = reads('version'), _class = (_class2 = class ItemFeeMembership extends ItemsV3Base {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "item", _descriptor, this);
    _initializerDefineProperty(this, "fee", _descriptor2, this);
    _initializerDefineProperty(this, "relationshipTrackerVersion", _descriptor3, this);
  }
  static catalogType() {
    return 'ITEM_FEE_MEMBERSHIP';
  }
}, _defineProperty(_class2, "_modelNameForMigration", 'item-fee-membership'), _class2), _descriptor = _applyDecoratedDescriptor(_class.prototype, "item", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "fee", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "relationshipTrackerVersion", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export default ItemFeeMembership;